import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import StoryblokVue from "storyblok-vue";
import Page from "@/components/storyblok/discounts/Page";
import Teaser from "@/components/storyblok/discounts/Teaser";
import Grid from "@/components/storyblok/discounts/Grid";
import Discount from "@/components/storyblok/discounts/Discount";
import Carousel from "@/components/storyblok/carousel/Carousel";
import CarouselItem from "@/components/storyblok/carousel/CarouselItem";
import store from "./store";
import "./registerServiceWorker";

Vue.config.productionTip = false;

Vue.use(StoryblokVue);
Vue.component("page", Page);
Vue.component("teaser", Teaser);
Vue.component("grid", Grid);
Vue.component("discount", Discount);
Vue.component("carousel", Carousel);
Vue.component("carouselitem", CarouselItem);

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount("#app");
